import(/* webpackMode: "eager" */ "/home/jubalj/builds/babyportal/apps/neocare-next/src/app/global-error.tsx");
